import React from 'react';
import { FormData, SubsidyCategory } from '../types/formTypes';

interface SubsidyCategoryFormProps {
  formData: FormData;
  updateFormData: (updates: Partial<FormData>) => void;
}

const subsidyCategories: { category: string; options: SubsidyCategory[] }[] = [
  {
    category: '人材育成支援コース',
    options: [
      '人材育成訓練',
      '認定実習併用職業訓練',
      'ＩＴ有期実習型訓練（基本型）',
      '有期実習型訓練（キャリアップ型）',
      '有期実習型訓練（派遣活用型）'
    ]
  },
  {
    category: '人への投資促進コース',
    options: [
      '定額制訓練',
      '自発的職業能力開発訓練（定額制サービスによる訓練以外）',
      '高度デジタル人材訓練',
      '成長分野等人材訓練',
      '情報技術分野野認定実習併用職業訓練'
    ]
  },
  {
    category: '事業展開等リスキリング支援コース',
    options: [
      '事業展開に伴い実施する訓練 a.定額制サービスによる訓練以外',
      '事業展開に伴い実施する訓練 b.定額制サービスによる訓練',
      '企業のDX・GXアドバンスワーカー a.定額制サービスによる訓練以外',
      '企業のDX・GXアドバンスワーカー b.定額制サービスによる訓練',
      '企業のグリーン・カーボンニュートラル化に伴い実施する訓練 a.定額制サービスによる訓練以外',
      '企業のグリーン・カーボンニュートラル化に伴い実施する訓練 b.定額制サービスによる訓練'
    ]
  }
];

const SubsidyCategoryForm: React.FC<SubsidyCategoryFormProps> = ({ formData, updateFormData }) => {
  return (
    <div className="form-section">
      <h2>2. 助成区分</h2>
      <p>該当する助成区分を選択してください *</p>
      
      {subsidyCategories.map((group) => (
        <div key={group.category} className="subsidy-group">
          <h3>{group.category}</h3>
          {group.options.map((option) => (
            <div key={option} className="radio-group">
              <label>
                <input
                  type="radio"
                  name="subsidyCategory"
                  value={option}
                  checked={formData.subsidyCategory === option}
                  onChange={(e) => updateFormData({ subsidyCategory: e.target.value as SubsidyCategory })}
                />
                {option}
              </label>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default SubsidyCategoryForm;